import useCurrentUser from 'hooks/useCurrentUser'
import React from 'react'
import ManageFiles from './ManageFiles';
import ClientManageFiles from './ClientManageFiles';

const MyFiles = () => {
    const { user } = useCurrentUser();
    return (
        <>
            {
                user?.roleType === 'PILOT' ? <ManageFiles /> : <ClientManageFiles />
            }
        </>
    )
}

export default MyFiles